import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  LEGACY_MEMBER_LOGIN_URL,
  LEGACY_MEMBER_URL,
} from "../../Enums/LegacyRedirection";
import AuthContext from "../../store/AuthContext";
import { getCookie } from "../../utils/cookies";

const LEGACY_PATH = "/my_preferences.asp";
const environment = process.env.REACT_APP_ENVIRONMENT as
  | "dev"
  | "testing"
  | "uat"
  | "prod";

export default function MyPreferencesLegacyTab(): React.ReactElement {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [token, setToken] = useState<string | null>(null);
  const [cookieSet, setCookieSet] = useState(false);
  const [iframeHeight, setIframeHeight] = useState("600px");
  const { loggedPerson, isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    setToken(getCookie("token"));
  }, []);

  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 220;
      const viewportHeight = window.innerHeight;
      setIframeHeight(`${Math.max(viewportHeight - headerHeight, 600)}px`);
    };
    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => window.removeEventListener("resize", calculateHeight);
  }, []);

  useEffect(() => {
    if (cookieSet) {
      return;
    }
    if (!token) {
      setCookieSet(true);
      return;
    }

    const seedIframe = document.createElement("iframe");
    seedIframe.style.display = "none";
    seedIframe.style.width = "0";
    seedIframe.style.height = "0";

    const url = new URL(LEGACY_MEMBER_LOGIN_URL);
    url.searchParams.append("token", token);

    const markCookieSet = () => setCookieSet(true);
    seedIframe.onload = markCookieSet;
    seedIframe.onerror = markCookieSet;
    seedIframe.src = url.toString();
    document.body.appendChild(seedIframe);

    return () => {
      if (seedIframe.parentNode) {
        seedIframe.parentNode.removeChild(seedIframe);
      }
    };
  }, [token, cookieSet]);

  const loadIframe = useCallback(() => {
    if (!iframeRef.current) {
      return;
    }

    const iframe = iframeRef.current;
    const url = new URL(`${LEGACY_MEMBER_URL}${LEGACY_PATH}`);
    const hideNavigation = Boolean(loggedPerson || isAuthenticated || token);

    url.searchParams.append("hide-navigation", hideNavigation.toString());
    if (token) {
      url.searchParams.append("token", token);
    }
    if (environment === "testing" || environment === "dev") {
      url.searchParams.append("test-environment", environment);
    }

    iframe.src = url.toString();
  }, [loggedPerson, isAuthenticated, token]);

  useEffect(() => {
    if (!cookieSet || !iframeRef.current) {
      return;
    }
    loadIframe();
  }, [cookieSet, loadIframe]);

  return (
    <div className="w-full" style={{ minHeight: iframeHeight }}>
      <iframe
        ref={iframeRef}
        className="w-full border-0"
        style={{ height: iframeHeight }}
        title="My Preferences"
      />
    </div>
  );
}
